import { registerPlugin } from "@capacitor/core";

export type NotificationPermissionStatus =
  | "notDetermined"
  | "denied"
  | "authorized"
  | "provisional"
  | "ephemeral"
  | "unknown";

export interface PermissionStatusResult {
  status: number;
  statusName: NotificationPermissionStatus;
}

export interface NativeNotificationPlugin {
  /**
   * Get current notification permission status.
   * Returns the iOS authorization level.
   */
  getPermissionStatus(): Promise<PermissionStatusResult>;

  /**
   * Request notification permission.
   * Triggers the iOS permission dialog if not yet determined.
   */
  requestPermission(): Promise<PermissionStatusResult>;

  /**
   * Clear the app badge and remove all delivered notifications.
   * This works without requiring Capacitor push registration.
   */
  clearBadge(): Promise<void>;
}

const NativeNotification = registerPlugin<NativeNotificationPlugin>("NativeNotification", {
  web: () =>
    import("./native-notification-web").then((m) => new m.NativeNotificationWeb()),
});

export default NativeNotification;
